module.exports = __webpack_public_path__ + "static/media/ZPC4.6c4b72a5.pdf";